import { Button, Dialog, DialogBody, DialogContent, DialogFooter, Select } from '@civilgrid/ui/components';
import type { PlanStatus } from '~/common/types';

export type PlanStatusOption = { value: PlanStatus; label: string };

export type EditPlanStatusDialogProps = {
  open: boolean;
  onClose: () => void;
  /** Empty string until the user (or a single-row prefill) picks a status. */
  planStatus: PlanStatus | '';
  onPlanStatusChange: (value: PlanStatus) => void;
  /** Org-aware options (PGE orgs relabel the statuses). */
  statusOptions: PlanStatusOption[];
  /** True when a status is chosen and differs from a single-row prefill. */
  canSubmit: boolean;
  onSubmit: () => void;
  isPending: boolean;
};

/** Bulk-edit modal for the Conflicts Summary table: one plan status applied to every selected row. */
export function EditPlanStatusDialog({
  open,
  onClose,
  planStatus,
  onPlanStatusChange,
  statusOptions,
  canSubmit,
  onSubmit,
  isPending,
}: EditPlanStatusDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        title="Edit Plan Status"
        preventDismiss={canSubmit}
        data-testid="conflicts-summary-edit-plan-status-dialog"
      >
        <DialogBody>
          <Select
            options={statusOptions}
            value={planStatus}
            onValueChange={(next) => next && onPlanStatusChange(next as PlanStatus)}
            placeholder="Select Status"
            aria-label="Plan status"
            triggerClassName="w-full"
            data-testid="conflicts-summary-edit-plan-status-dialog-select"
          />
        </DialogBody>
        <DialogFooter>
          <Button variant="secondary" onClick={onClose} data-testid="conflicts-summary-edit-plan-status-dialog-cancel">
            Cancel
          </Button>
          <Button
            onClick={onSubmit}
            disabled={isPending || !canSubmit}
            data-testid="conflicts-summary-edit-plan-status-dialog-apply"
          >
            {isPending ? 'Updating…' : 'Apply'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
